import { FC, useState } from 'react';

import { BreakdownsResult } from 'api/useAnalytics';
import { LabelList, Pie, Sector } from 'recharts';
import { PieSectorDataItem } from 'recharts/types/polar/Pie';

import { AnalyticsPieBox } from '../AnalyticsPieBox';
import { usePieChartConfig } from '../hooks/use-pie-chart-config';

type AnalyticsPieDonutProps = {
  isLoading: boolean;
  shouldDisplayLegend?: boolean;
  shouldDisplayLabel?: boolean;
  shouldDisplayValue?: boolean;
  breakdown: BreakdownsResult | undefined;
};

export const AnalyticsPieDonut: FC<AnalyticsPieDonutProps> = ({
  isLoading,
  breakdown,
  shouldDisplayLegend = true,
  shouldDisplayLabel = false,
  shouldDisplayValue = false
}) => {
  const [activeIndex, setActiveIndex] = useState<number | undefined>(undefined);
  const { chartData } = usePieChartConfig({ breakdown });

  return (
    <AnalyticsPieBox
      isLoading={isLoading}
      breakdown={breakdown}
      shouldDisplayLegend={shouldDisplayLegend}
    >
      <Pie
        data={chartData}
        dataKey="value"
        nameKey="breakdownValue"
        innerRadius={60}
        outerRadius={95}
        strokeWidth={5}
        activeIndex={activeIndex}
        activeShape={({ outerRadius = 0, ...props }: PieSectorDataItem) => (
          <Sector {...props} outerRadius={outerRadius + 10} />
        )}
        onMouseEnter={(_, index) => setActiveIndex(index)}
        onMouseLeave={() => setActiveIndex(undefined)}
        isAnimationActive={false}
      >
        {(shouldDisplayLabel || shouldDisplayValue) && (
          <LabelList
            dataKey={shouldDisplayValue ? 'value' : 'breakdownValue'}
            stroke="white"
            fontSize={12}
            strokeWidth={1}
            fontWeight={300}
          />
        )}
      </Pie>
    </AnalyticsPieBox>
  );
};
